import { UserManager, WebStorageStateStore } from 'oidc-client';
import Routes from '../../constants/routes';
import { hasSucceeded } from '../../../libs/utils/constants/async-status';
import store from '../../app/store';

const BASE_APP_URL = window.location.origin;
const IDENTITY_PROVIDER_POST_LOGOUT_CALLBACK = `${BASE_APP_URL}${Routes.LOGOUT}`;
const IDENTITY_PROVIDER_CALLBACK = `${BASE_APP_URL}${Routes.LOGIN_CALLBACK}`;
const IDENTITY_PROVIDER_SILENT_CALLBACK = `${BASE_APP_URL}${Routes.SILENT_LOGIN_CALLBACK}`;
const KEYCLOAK_PROTOCOL = 'protocol/openid-connect';

let IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL: string;
let POINT_OF_CARE_CLIENT_ID: string;
let USE_KEYCLOAK: boolean;
let KEYCLOAK_DOMAIN_URL: string;
let KEYCLOAK_POINT_OF_CARE_CLIENT_ID: string;
let LOGIN_BASE_URL: string;

const getValuesfromStore = () => {
    store.subscribe(() => {
        const valuesFromStore = store.getState().appConfigs;
        if (
            Object.keys(valuesFromStore.appConfigs).length > 0 &&
            hasSucceeded(valuesFromStore.appConfigsAsyncStatus)
        ) {
            USE_KEYCLOAK = valuesFromStore.appConfigs.USE_KEYCLOAK === 'true';
            KEYCLOAK_DOMAIN_URL =
                valuesFromStore.appConfigs.KEYCLOAK_DOMAIN_URL;
            KEYCLOAK_POINT_OF_CARE_CLIENT_ID =
                valuesFromStore.appConfigs.KEYCLOAK_POINT_OF_CARE_CLIENT_ID;
            IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL =
                valuesFromStore.appConfigs.IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL;
            POINT_OF_CARE_CLIENT_ID =
                valuesFromStore.appConfigs.POINT_OF_CARE_CLIENT_ID;
            LOGIN_BASE_URL = valuesFromStore.appConfigs.LOGIN_BASE_URL;
        }
    });
};
getValuesfromStore();

const getKeycloakConfig = () => ({
    authority: KEYCLOAK_DOMAIN_URL,
    client_id: KEYCLOAK_POINT_OF_CARE_CLIENT_ID,
    redirect_uri: IDENTITY_PROVIDER_CALLBACK,
    silent_redirect_uri: IDENTITY_PROVIDER_SILENT_CALLBACK,
    response_type: 'code',
    scope: 'openid profile email',
    filterProtocolClaims: false,
    loadUserInfo: false,
    accessTokenExpiringNotificationTime: 5,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    metadata: {
        issuer: `${KEYCLOAK_DOMAIN_URL}`,
        authorization_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/auth`,
        token_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/token`,
        userinfo_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/userinfo`,
        jwks_uri: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/certs`,
        end_session_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/logout?client_id=${KEYCLOAK_POINT_OF_CARE_CLIENT_ID}&post_logout_redirect_uri=${encodeURIComponent(
            LOGIN_BASE_URL
        )}`,
    },
});

const getConfig = () => ({
    authority: IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL,
    client_id: POINT_OF_CARE_CLIENT_ID,
    redirect_uri: IDENTITY_PROVIDER_CALLBACK,
    silent_redirect_uri: IDENTITY_PROVIDER_SILENT_CALLBACK,
    response_type: 'code',
    scope: 'openid profile email',
    filterProtocolClaims: false,
    loadUserInfo: false,
    accessTokenExpiringNotificationTime: 5,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    metadata: {
        issuer: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/`,
        authorization_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/authorize`,
        token_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/oauth/token`,
        userinfo_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/userinfo`,
        jwks_uri: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/.well-known/jwks.json`,
        end_session_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/v2/logout?client_id=${POINT_OF_CARE_CLIENT_ID}&returnTo=${encodeURIComponent(
            IDENTITY_PROVIDER_POST_LOGOUT_CALLBACK
        )}`,
    },
});

const appUserManagerSetup = async () => {
    let oidcConfig;
    if (USE_KEYCLOAK) {
        oidcConfig = await getKeycloakConfig();
    } else {
        oidcConfig = await getConfig();
    }
    const appUserManager = new UserManager(oidcConfig);

    // Clean stale state once at startup
    appUserManager.clearStaleState().catch(console.warn);

    appUserManager.events.addAccessTokenExpiring(() => {
        console.log('token expiring...');
    });
    appUserManager.events.addAccessTokenExpired(() => {
        localStorage.removeItem('IS_USER_AUTHENTICATED');
        console.log('token expired...');
    });
    appUserManager.events.addSilentRenewError((e) => {
        console.log('silent renew error', e.message);
    });
    appUserManager.events.addUserLoaded(() => {
        console.log('user loaded');
    });
    appUserManager.events.addUserUnloaded(() => {
        console.log('user cleared');
    });
    return appUserManager;
};

export default appUserManagerSetup;
